import useAppFormatAmount from '../../../app/features/format/hooks/useAppFormatAmount';

const useUserSettingRoundings = () => {
	const { displayRoundingSuffix } = useAppFormatAmount();

	const roundings = [
		{
			tag: 'k',
			name: displayRoundingSuffix('k') + '€',
		},
		{
			tag: 'm',
			name: displayRoundingSuffix('m') + '€',
		},
		{
			tag: 'b',
			name: displayRoundingSuffix('b') + '€',
		},
	];

	return roundings;
};

export default useUserSettingRoundings;
